import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Nav from './components/Nav';
import Footer from './components/Footer';
import Design6 from './designs/Design6';
import { ThemeProvider } from './theme/ThemeContext';

const navItems = [
    { id: 'about', label: 'About' },
    { id: 'career', label: 'Career' },
    { id: 'skills', label: 'Skills' },
    { id: 'projects', label: 'Projects' },
    { id: 'contact', label: 'Contact' },
];

function App() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <ThemeProvider>
            <BrowserRouter>
                <Nav items={navItems} scrolled={scrolled} />
                <Routes>
                    <Route path="/" element={<Design6 />} />
                </Routes>
                <Footer />
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;